import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import CssBaseline from '@mui/material/CssBaseline';
import FormControlLabel from '@mui/material/FormControlLabel';
import Divider from '@mui/material/Divider';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';

import ForgotPassword from './ForgotPassword';
import { THCIcon } from './Icons';
import { useLoginUserMutation } from '../store/auth/AuthApi';
import { useSelector } from 'react-redux';

import { Navigate, useLocation } from "react-router-dom";

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '450px',
  },
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
  height: 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',
  minHeight: '100%',
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4),
  },
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
    ...theme.applyStyles('dark', {
      backgroundImage:
        'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    }),
  },
}));

function Login(props) {
  const [emailError] = React.useState(false);
  const [emailErrorMessage] = React.useState('');
  const [passwordError] = React.useState(false);
  const [passwordErrorMessage] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const location = useLocation();
  const from = location.state?.from || '/';
  const [login] = useLoginUserMutation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (event) => {
    // wir dürfen auf gar keinen Fall irgendwas über die
    // Form versenden - wir machen das schließlich selbst
    // und setzen daher: preventDefault
     event.preventDefault();     
    const email = document.getElementById('email').value.toString().toLowerCase();
    const password = document.getElementById('password').value;

    // Vorbereiten der Benutzerdaten
    const credentials = {
      username: email, 
      password: password,
    };

    // Wir ermitteln direkt die Daten über ReduxQuery...  
    login(credentials);
    //login(credentials)
    //.unwrap()
    //.then((payload) => console.log('fulfilled', payload))
    //.catch((error) => console.error('rejected', error));    
  };

  if (isAuthenticated) 
  {
    //return <Navigate to="/" />;
    return <Navigate to={from} />;
  }

  return (
    <>
      <CssBaseline enableColorScheme />
      <SignInContainer direction="column" justifyContent="space-between">
        <Card variant="outlined">
          <THCIcon />Pfingstturnier des 1. Hanauer THCs
          <Typography
            component="h1"
            variant="h4"
            sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
          >
            Einloggen
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            method="Post"
            noValidate
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: 2,
            }}
          >
            <FormControl>
              <FormLabel htmlFor="email">E-Mail</FormLabel>
              <TextField
                error={emailError}
                helperText={emailErrorMessage}
                id="email"
                type="email"
                name="email"
                placeholder="deine@email.de"
                autoComplete="email"
                autoFocus
                required
                fullWidth
                variant="outlined"
                color={emailError ? 'error' : 'primary'}                
              />
            </FormControl>
            <FormControl>
              <FormLabel htmlFor="password">Passwort</FormLabel>
              <TextField
                error={passwordError}
                helperText={passwordErrorMessage}
                name="password"
                placeholder="••••••••"
                type="password"
                id="password"
                autoComplete="current-password"
                autoFocus
                required
                fullWidth
                variant="outlined"
                color={passwordError ? 'error' : 'primary'}
              />
            </FormControl>
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Eingelogged bleiben"
            />
            <ForgotPassword open={open} handleClose={handleClose} />
            <Button
              type="submit"
              fullWidth
              variant="contained"
            >
              Einloggen
            </Button>
            <Link
              component="button"
              type="button"
              onClick={handleClickOpen}
              variant="body2"
              sx={{ alignSelf: 'center' }}
            >
              Passwort vergessen?
            </Link>
          </Box>
          <Divider>oder</Divider>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography sx={{ textAlign: 'center' }}>
              Mich und eine Mannschaft{' '}
              <Link
                href="/material-ui/getting-started/templates/sign-in/"
                variant="body2"
                sx={{ alignSelf: 'center' }}
              >
                anmelden
              </Link>?
            </Typography>
          </Box>
        </Card>
      </SignInContainer>
    </>
  );
}


/*
 * wird derzeit nicht mehr verwendet

const validateInputs = () => {
  const email = document.getElementById('email');
  const password = document.getElementById('password');

  // Wir merken uns die Daten trotzdem schon einmal: 
  setCredentials({username:email, password:password});

  let isValid = true;

  if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
    setEmailError(true);
    setEmailErrorMessage('Bitte geben Sie eine valide E-Mail Adresse an');
    isValid = false;
  } else {
    setEmailError(false);
    setEmailErrorMessage('');
  }

  if (!password.value || password.value.length < 8) 
  {
    setPasswordError(true);
    setPasswordErrorMessage('Das Passwort muss mindestens 8 Zeichen haben ');
    isValid = false;
  } 
  else 
  {
    var hasUpperCase = /[A-Z]/.test(password);
    var hasLowerCase = /[a-z]/.test(password);
    var hasNumbers = /\d/.test(password);
    var hasNonalphas = /\W/.test(password);

    if (hasUpperCase + hasLowerCase + hasNumbers + hasNonalphas < 3)
    {
      setPasswordError(true);
      setPasswordErrorMessage('Passwort mit Groß- und Kleinbuchstaben, Nummern und Zeichen');
      isValid = false;    
    } 
    else 
    {
      setPasswordError(false);
      setPasswordErrorMessage('');
    }
  }
  return isValid;
};

*/

export default Login;